import { render, staticRenderFns } from "./IamIdentities.vue?vue&type=template&id=b2c46ff4&scoped=true&"
import script from "./IamIdentities.vue?vue&type=script&lang=js&"
export * from "./IamIdentities.vue?vue&type=script&lang=js&"
import style0 from "./IamIdentities.vue?vue&type=style&index=0&id=b2c46ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c46ff4",
  null
  
)

export default component.exports